import { CSSProperties } from "react";
import { compareDesc } from "date-fns";

export const arrayIntersect = (
  array1: Array<string | number>,
  array2: Array<string | number>
): Array<string | number> => array1.filter(item => array2.includes(item));

export const hasBackgroundImage = (
  pathname: string,
  theme: string
): CSSProperties | undefined => {
  const hasBG = [
    "home",
    "about",
    "complete-profile",
    "download",
    "appfeedback",
    "maintenance-mode"
  ];
  const routeParts = pathname.split("/").filter((r: string) => !!r);

  let backgroundStyle;
  if (hasBG.some(item => routeParts.includes(item))) {
    const background = `/img/home-background-${theme}.jpg`;
    backgroundStyle = {
      marginTop: 0,
      backgroundImage: `url(${background})`,
      backgroundSize: "cover",
      backgroundPosition: "center center"
    };
  }

  return backgroundStyle;
};

export const getLastDetectedDate = (
  desktopLastDetected?: string,
  mobileLastDetected?: string
): Date | undefined => {
  let latestDate;
  //If both dates are undefined then we return undefined
  if (!desktopLastDetected && !mobileLastDetected) {
    return undefined;
  }

  if (mobileLastDetected && desktopLastDetected) {
    //If we have both we have to compare them and return the highest one
    const mobileDate = new Date(mobileLastDetected);
    const desktopDate = new Date(desktopLastDetected);

    //compareDesc returns -1 if the first date is after the second, else it returns 1
    latestDate =
      compareDesc(mobileDate, desktopDate) === -1 ? mobileDate : desktopDate;
  } else if (desktopLastDetected && !mobileLastDetected) {
    //If there is a desktop last detected but not mobile we set desktop as latest date
    latestDate = new Date(desktopLastDetected);
  } else if (mobileLastDetected && !desktopLastDetected) {
    //If there is a mobile last detected but not desktop we set mobile as latest date
    latestDate = new Date(mobileLastDetected);
  } else {
    latestDate = undefined;
  }

  return latestDate;
};
